<template>
  <button @click="toggleLanguage" class="language-toggle">
    {{ locale === 'zh' ? '中' : 'EN' }}
  </button>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSelector',
  setup() {
    const { locale } = useI18n()

    const toggleLanguage = () => {
      const next = locale.value === 'zh' ? 'en' : 'zh'
      locale.value = next
      localStorage.setItem('userLocale', next)
    }

    return { locale, toggleLanguage }
  }
}
</script>

<style scoped>
.language-toggle {
  padding: 0.3rem 0.6rem;
  border: 1px solid var(--color-brand-100);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-brand-600);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 0.5rem;
}

.language-toggle:hover {
  background-color: var(--color-brand-50);
}

@media (max-width: 768px) {
  .language-toggle {
    min-width: 38px;
    height: 30px;
    padding: 0 0.55rem;
    border-radius: var(--radius-pill);
    font-size: 0.72rem;
    margin-right: 0;
    background: var(--color-surface);
  }
}
</style>
